module.exports = "/_next/static/images/ryuunoko_top-bbc933650ed995f5697b9ac487d9a7cc.jpg";